export default __webpack_public_path__ + "static/media/certificate1.f4553f89.png";